import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PasswordChangeSuccess = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center px-4 bg-gray-100">
            <div className="w-full max-w-md bg-white rounded-lg shadow-md p-8 text-center">
                <p className="text-2xl font-semibold text-green-600">{t("Password Changed!")}</p>
                <p className="mt-2 text-gray-600">
                    {t("Your password has been updated successfully.")}
                </p>
                <button
                    className="mt-6 w-full bg-black hover:bg-black-800 text-white py-2 px-4 rounded-md transition duration-200"
                    onClick={() => navigate('/')}
                >
                    {t("Back to Login")}
                </button>
            </div>
        </div>
    );
};

export default PasswordChangeSuccess;